module.exports = __webpack_public_path__ + "img/videoicon.1cbdf9c8.svg";